import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Table, Tag, DatePicker } from 'antd';
import {
  AppstoreOutlined,
  TeamOutlined,
  UserOutlined,
  DownloadOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons';
import './Dashboard.css';
import './AdminCommon.css';

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalSkills: 156,
    totalExperts: 48,
    totalUsers: 1234,
    totalDownloads: 5678,
    skillGrowth: 12.5,
    expertGrowth: 8.3,
    userGrowth: 23.1,
    downloadGrowth: 45.2,
  });

  const [recentActivities, setRecentActivities] = useState([
    { id: 1, action: '用户注册', user: '张三', time: '2026-05-29 14:30', status: 'success' },
    { id: 2, action: '技能上传', user: '李四', time: '2026-05-29 14:25', status: 'pending' },
    { id: 3, action: '专家认证', user: '王五', time: '2026-05-29 14:20', status: 'success' },
    { id: 4, action: '技能下载', user: '赵六', time: '2026-05-29 14:15', status: 'success' },
    { id: 5, action: '订单创建', user: '钱七', time: '2026-05-29 14:10', status: 'success' },
  ]);

  const columns = [
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
    },
    {
      title: '用户',
      dataIndex: 'user',
      key: 'user',
    },
    {
      title: '时间',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        <Tag color={status === 'success' ? 'green' : status === 'pending' ? 'orange' : 'red'}>
          {status === 'success' ? '成功' : status === 'pending' ? '待审核' : '失败'}
        </Tag>
      ),
    },
  ];

  return (
    <div className="admin-dashboard">
      <div className="page-header">
        <h1 className="page-title">数据概览</h1>
        <p className="page-subtitle">实时查看平台运营数据</p>
      </div>

      {/* 统计卡片 */}
      <Row gutter={24} className="stats-row">
        <Col span={6}>
          <Card className="stat-card">
            <Statistic
              title="总技能数"
              value={stats.totalSkills}
              prefix={<AppstoreOutlined />}
              suffix={
                <span className={`growth ${stats.skillGrowth > 0 ? 'up' : 'down'}`}>
                  {stats.skillGrowth > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                  {Math.abs(stats.skillGrowth)}%
                </span>
              }
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card">
            <Statistic
              title="认证专家"
              value={stats.totalExperts}
              prefix={<TeamOutlined />}
              suffix={
                <span className={`growth ${stats.expertGrowth > 0 ? 'up' : 'down'}`}>
                  {stats.expertGrowth > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                  {Math.abs(stats.expertGrowth)}%
                </span>
              }
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card">
            <Statistic
              title="注册用户"
              value={stats.totalUsers}
              prefix={<UserOutlined />}
              suffix={
                <span className={`growth ${stats.userGrowth > 0 ? 'up' : 'down'}`}>
                  {stats.userGrowth > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                  {Math.abs(stats.userGrowth)}%
                </span>
              }
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="stat-card">
            <Statistic
              title="总下载量"
              value={stats.totalDownloads}
              prefix={<DownloadOutlined />}
              suffix={
                <span className={`growth ${stats.downloadGrowth > 0 ? 'up' : 'down'}`}>
                  {stats.downloadGrowth > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                  {Math.abs(stats.downloadGrowth)}%
                </span>
              }
            />
          </Card>
        </Col>
      </Row>

      {/* 图表区域 */}
      <Row gutter={24} className="charts-row">
        <Col span={16}>
          <Card title="趋势分析" className="chart-card">
            <div className="chart-placeholder">
              <p>📈 用户增长趋势图</p>
              <p>（集成图表库后显示）</p>
            </div>
          </Card>
        </Col>
        <Col span={8}>
          <Card title="技能分类分布" className="chart-card">
            <div className="chart-placeholder">
              <p>🥧 分类占比饼图</p>
              <p>（集成图表库后显示）</p>
            </div>
          </Card>
        </Col>
      </Row>

      {/* 最近活动 */}
      <Card title="最近活动" className="activity-card">
        <Table
          columns={columns}
          dataSource={recentActivities}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </Card>
    </div>
  );
};

export default Dashboard;
